import { ArrowLeftEndOnRectangleIcon } from '@heroicons/react/24/outline'
import api from '../../api/backend'
import { Button } from '../ui/new/button'

const FEDERATED_AUTH = Number(import.meta.env.VITE_APP_FEDERATED_AUTH)

type Props = {
  expanded: boolean
}

const FederatedAuthButton = ({ expanded = false }: Props) => {
  return (
    <Button variant={`${expanded ? 'primary' : 'ghost'}`}>
      <a href={api.OIDC_LOGIN_URL} className="flex flex-row gap-1">
        <ArrowLeftEndOnRectangleIcon className="w-5 h-5" />
        {expanded && 'Entrar'}
      </a>
    </Button>
  )
}

const SigarraAuthButton = ({ expanded = false }: Props) => {
  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault()

        const res = await fetch(`${api.BACKEND_URL}/sigarra_login/`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'X-CSRFToken': api.getCSRFToken() || '',
          },
        })

        if (res.ok) {
          window.location.reload()
        } else {
          console.error(`Login failed with status: ${res.status}`)
        }
      }}
    >
      <Button variant={`${expanded ? 'primary' : 'ghost'}`} type="submit">
        <ArrowLeftEndOnRectangleIcon className="w-5 h-5" />
        {expanded && 'Entrar'}
      </Button>
    </form>
  )
}

export const LoginButton = ({ expanded = false }: Props) => {
  return (
    <>
      {FEDERATED_AUTH === 1 ? <FederatedAuthButton expanded={expanded} /> : <SigarraAuthButton expanded={expanded} />}
    </>
  )
}
